export default __webpack_public_path__ + "static/media/rnr-sports-table-17-cn.a65435ae.webp";